import { Box } from '@material-ui/core';
import { LoadingScreen } from 'components/Loaders';
import { 
  func, 
  number, 
  string,
} from 'prop-types';
import { Img } from 'react-image';


const ImageViewer = (props) => {
  const {
    contentUrl,
    pdfWidth,
    rotation,
    setFileState,
  } = props;
  return (
    <Box 
      style={{
        display: 'grid',
        placeItems: 'center',
        transform: `rotate(${rotation}deg)`,
        transition: 'transform 0.3s ease',
        width: '100%',
        height: '100%',
      }}
    >
      <Img
        src={contentUrl}
        loader={<LoadingScreen />}
        unloader={() => setFileState((prev) => ({
          ...prev,
          error: 'No se pudo cargar la imagen',
        }))}
        style={{ 
          width: pdfWidth,
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

ImageViewer.propTypes = {
  contentUrl: string,
  pdfWidth: number,
  rotation: number,
  setFileState: func,
};

export default ImageViewer;
